import {
  EventBus,
  HMSAudioPlugin,
  HMSAudioPluginType,
  HMSPluginSupportResult,
} from "@100mslive/hms-video-store";
import KrispSDK, { AudioFilterNode } from "./krisp";
import { getAnalyticsEvent } from "./utils";

export class HMSKrispPlugin implements HMSAudioPlugin {
  private sdk: KrispSDK | null = null;
  private readonly TAG = "[HMSKrispPlugin]";
  private filterNode: AudioFilterNode | undefined = undefined;
  private eventBus?: EventBus;

  checkSupport(): HMSPluginSupportResult {
    return {
      isSupported: KrispSDK.isSupported(),
    };
  }

  setEventBus(eventBus: EventBus) {
    this.eventBus = eventBus;
  }
  async init() {
    this.sdk = new KrispSDK({
      params: {
        debugLogs: false,
        logProcessStats: false,
        useSharedArrayBuffer: false,
        // useBVC: true,
        models: {
          // modelBVC: 'https://assets.100ms.live/krisp/models/model_bvc.kw',
          model8: "https://assets.100ms.live/krisp/models/model_8.kw",
          model16: "https://assets.100ms.live/krisp/models/model_16.kw",
          model32: "https://assets.100ms.live/krisp/models/model_32.kw",
        },
      },
    });
    await this.sdk.init();
  }
  getPluginType() {
    return HMSAudioPluginType.TRANSFORM;
  }

  getName() {
    return "HMSKrispPlugin";
  }
  isSupported() {
    return KrispSDK.isSupported();
  }

  toggle() {
    const isKrispEnabled = this.isEnabled();
    const eventName = `mediaPlugin.toggled.${isKrispEnabled ? "off" : "on"}`;
    this.eventBus?.analytics.publish(getAnalyticsEvent(eventName));
    this.filterNode?.toggle();
  }

  isEnabled() {
    return this.filterNode?.isEnabled();
  }

  async processAudioTrack(ctx: AudioContext, source: AudioNode) {
    this.filterNode = await this.sdk?.createNoiseFilter(
      ctx,
      () => {
        if (this.filterNode) {
          this.filterNode?.enable();
          console.log(this.TAG, "filter node created and enabled");
          source.connect(this.filterNode);
        }
      },
      () => {},
    );
    return this.filterNode!;
  }
  stop() {
    this.sdk = null;
  }
}
